// extracted by mini-css-extract-plugin
module.exports = {"login":"style_login__XuBFm","fullscreen":"style_fullscreen__36lha","windowed":"style_windowed__RACod","header":"style_header__31arz","logo":"style_logo__Uo2hq"};